import { styled } from "@mui/system";
import React, { useState, useCallback, useMemo, useRef, useEffect } from "react";
import { FaBuilding } from "react-icons/fa";
import { Handle, Position } from "reactflow";
import OrganizationModal from "./OrganizationModal";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import { selectnodess } from "../redux/nodesSlice";
import { selectgroups } from "../redux/businessSlice";
import {
  selectisEdit,
  setMinusClicked,
  setPlusClicked,
} from "../redux/nodePositionedSlice";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import {
  toggleNodeSelection,
  selectSelectedNodes,
  unselectNode,
} from "../redux/selectedNodesSlice";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";
import { useUpdateOrganizationMutation } from "../redux/organizationApi";
// import { TruckFlatbed } from "react-bootstrap-icons";

function TextUpdaterNode({ data, isConnectable }) {
  const dispatch = useDispatch();
  const alldataorg = useSelector(selectnodess);
  const groups = useSelector(selectgroups);
  const isEdit = useSelector(selectisEdit);
  const rootRef = useRef(null);
  // // console.log("alldatatorg", alldataorg);
  const [openmodal, setOpenmodal] = useState(false);
  const [topBackGroundColor, setTopBackGroundColor] = useState(
    data.showBackground
  );
  const [anchorEl, setAnchorEl] = useState(null);
  // const [selectbox, setSelectbox] = useState();
  const open1 = Boolean(anchorEl);

  const groupfilter = useCallback(
    (id) => {
      if (!Array.isArray(groups)) {
        return "";
      }
      const found = groups.find((item) => item._id === id);
      return found?.businessNature || "";
    },
    [groups]
  );

  const groupcolor = useCallback(
    (id) => {
      if (!Array.isArray(groups)) {
        return "";
      }
      const found = groups.find((item) => item._id === id);
      return found?.businessColor || "";
    },
    [groups]
  );

  const handlePopoverOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handlePopoverClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const selectedNodes = useSelector(selectSelectedNodes);
  // console.log("selectedNodes", selectedNodes);

  const isSelected = useMemo(
    () => selectedNodes?.some((item) => item.nodeId === data?.nodeId),
    [selectedNodes, data?.nodeId]
  );

  const getAllDescendants = useCallback((nodeId, nodes) => {
    let result = [];
    const node = nodes.find((item) => item._id === nodeId);
    if (node) {
      result.push(node);
      node.children?.forEach((child) => {
        result = result.concat(getAllDescendants(child._id, nodes)); // Recursively add descendants
      });
    }
    return result;
  }, []);

  const handleCheckboxChange = useCallback(
    (isChecked) => {
      const allData = getAllDescendants(data._id, alldataorg);
      if (isChecked) {
        allData?.forEach((item) => {
          dispatch(toggleNodeSelection(item?.data));
        });
      } else {
        allData?.forEach((item) => {
          dispatch(unselectNode(item?.data));
        });
      }
    },
    [alldataorg, data._id, dispatch, getAllDescendants]
  );

  //  % by colors
  const calculateSharePercentageAndColor = useCallback((data) => {
    // Default return value
    const defaultReturn = {
      totalOwnedShares: 0,
      percentageOfShares: "0.00",
      color: data?.isBranch === true ? "#adf3ad" : "",
    };

    if (!data) {
      return defaultReturn;
    }

    const { totalNoOfShares, shareHolders } = data;

    // Ensure totalNoOfShares is a valid number
    const totalShares = parseFloat(totalNoOfShares);
    if (isNaN(totalShares) || totalShares <= 0) {
      return defaultReturn;
    }

    // Ensure shareHolders is an array
    if (!Array.isArray(shareHolders)) {
      return defaultReturn;
    }

    // Reduce the `shareHolders` array to calculate total shares owned
    const totalOwnedShares = shareHolders.reduce((sum, entity) => {
      const sharesOwned = parseFloat(entity?.numberSharesOwned || 0);
      return sum + (isNaN(sharesOwned) ? 0 : sharesOwned);
    }, 0);

    // Calculate the percentage of owned shares
    const percentageOfShares = (totalOwnedShares / totalShares) * 100;

    // Determine the color based on the percentage
    let color = "";
    if (percentageOfShares === 100) {
      color = "yellow";
    } else if (percentageOfShares > 50 && percentageOfShares < 100) {
      color = "#ADD8E6";
    } else if (percentageOfShares >= 20 && percentageOfShares <= 50) {
      color = "#FFB6C1";
    } else if (data?.isBranch === true) {
      color = "#adf3ad";
    }

    return {
      totalOwnedShares,
      percentageOfShares: percentageOfShares.toFixed(2),
      color,
    };
  }, []);

  const shareData = useMemo(
    () => calculateSharePercentageAndColor(data),
    [calculateSharePercentageAndColor, data]
  );
  const dynamicColor = shareData?.color || "";

  const RoundedIconButton = useMemo(
    () =>
      styled(IconButton)({
        borderRadius: "50%",
        color: "white",
        fontSize: "1rem",
        backgroundColor: `${
          data.isBranch && data.branch === true
            ? "red"
            : data.checked === true
            ? "red"
            : groupcolor(data.BusinessGroup)
        }`,
        "&:hover": {
          backgroundColor: "blue",
        },
      }),
    [data.isBranch, data.branch, data.checked, data.BusinessGroup, groupcolor]
  );

  const RoundedIconButton2 = useMemo(
    () =>
      styled(IconButton)({
        borderRadius: "50%",
        color: "white",
        fontSize: "1rem",
        backgroundColor: `${
          data.isBranch && data.branch === true
            ? "red"
            : data.checked === true
            ? "red"
            : "green"
        }`,
        "&:hover": {
          backgroundColor: "red",
        },
      }),
    [data.isBranch, data.branch, data.checked]
  );

  // Initialize and cleanup Bootstrap tooltips only within this node's DOM subtree
  useEffect(() => {
    if (!rootRef.current) return;

    const tooltipTriggerList = Array.from(
      rootRef.current.querySelectorAll('[data-bs-toggle="tooltip"]')
    );

    const tooltipInstances = tooltipTriggerList.map(
      (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    );

    return () => {
      tooltipInstances.forEach((instance) => {
        if (instance && typeof instance.dispose === "function") {
          instance.dispose();
        }
      });
    };
  }, []);

  const filterName = useCallback(
    (id) => {
      const found = alldataorg?.find((item) => item._id === id?.toString());
      return found?.data?.companyName;
    },
    [alldataorg]
  );

  return (
    <>
      <div
        className=""
        ref={rootRef}
        onClick={() => setTopBackGroundColor(true)}
      >
        <div className={`text-updater-node`} style={{ width: "34rem" }}>
          <div className="main-card position-relative">
            <div className="d-flex">
              <div
                className="card-head ms-3 me-2 pt-3 pb-3"
                style={{ width: "26rem" }}
              >
                <div
                  color={topBackGroundColor ? "white" : "black"}
                  className="upper d-flex position-relative"
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      zIndex: 1000,
                    }}
                  >
                    <LargeCheckbox
                      checked={isSelected}
                      onChange={(event) =>
                        handleCheckboxChange(event.target.checked)
                      }
                      inputProps={{ "aria-label": "Select node" }}
                    />
                  </div>

                  <div
                    style={{
                      width: "20%",
                      backgroundColor:
                        data.isBranch === true && data.branch === false
                          ? topBackGroundColor
                            ? "green"
                            : "#b7e4c7"
                          : data.jointcompany === true
                          ? "gray"
                          : data.branch && data.isBranch === true
                          ? "red"
                          : data.checked === true
                          ? "red"
                          : topBackGroundColor
                          ? groupcolor(data.BusinessGroup)
                          : groupcolor(data.BusinessGroup),
                    }}
                    className="con1"
                  ></div>

                  <div
                    style={
                      data.jointcompany === true
                        ? {
                            width: "15%",
                            height: "100%",
                            borderBottom: "25px solid gray",
                            borderLeft: "0px",
                            borderRight: "35px solid transparent",
                          }
                        : data.isBranch === true && data.branch === false
                        ? {
                            width: "15%",
                            height: "100%",
                            borderBottom: `25px solid ${
                              topBackGroundColor ? "green" : "#b7e4c7"
                            }`,
                            borderLeft: "0px",
                            borderRight: "35px solid transparent",
                          }
                        : data.branch && data.isBranch === true
                        ? {
                            width: "15%",
                            height: "100%",
                            borderBottom: `25px solid ${
                              topBackGroundColor ? "red" : "red"
                            }`,
                            borderLeft: "0px",
                            borderRight: "35px solid transparent",
                          }
                        : data.checked === true
                        ? {
                            width: "15%",
                            height: "100%",
                            borderBottom: `25px solid ${
                              topBackGroundColor ? "red" : "red"
                            }`,
                            borderLeft: "0px",
                            borderRight: "35px solid transparent",
                          }
                        : {
                            width: "15%",
                            height: "100%",
                            borderBottom: `25px solid ${
                              topBackGroundColor
                                ? groupcolor(data.BusinessGroup)
                                : groupcolor(data.BusinessGroup)
                            }`,
                            borderLeft: "0px",
                            borderRight: "35px solid transparent",
                          }
                    }
                  />
                  <div
                    style={{ width: "75%", opacity: "0%" }}
                    className="con2 bg-dark"
                  ></div>
                  {!isEdit && (
                    <div
                      style={{
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        display: "flex",
                        gap: "10px",
                      }}
                      className="position-absolute right-0 top-0 mx-auto"
                    >
                      <div className="d-flex gap-2">
                        <div
                          onMouseDown={(e) => {
                            // prevent React Flow from starting a pan/drag
                            e.stopPropagation();
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            dispatch(
                              setPlusClicked({ id: data.nodeId, click: true })
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {data.isBranch === true ? (
                            <RoundedIconButton2>
                              <AddIcon />
                            </RoundedIconButton2>
                          ) : (
                            <RoundedIconButton>
                              <AddIcon />
                            </RoundedIconButton>
                          )}
                        </div>
                        <div
                          onMouseDown={(e) => {
                            // prevent React Flow from starting a pan/drag
                            e.stopPropagation();
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            dispatch(setMinusClicked({ click: true }));
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {data.isBranch === true ? (
                            <RoundedIconButton2>
                              <RemoveIcon />
                            </RoundedIconButton2>
                          ) : (
                            <RoundedIconButton>
                              <RemoveIcon />
                            </RoundedIconButton>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  onClick={() => {
                    if (
                      !data?.isBranch &&
                      data?.isBranch === false &&
                      !data?.jointcompany &&
                      data?.jointcompany === false
                    ) {
                      setOpenmodal(true);
                    }
                  }}
                  style={
                    data.jointcompany === true
                      ? {
                          backgroundColor: "gray",
                        }
                      : data.isBranch === true && data.branch === false
                      ? {
                          backgroundColor: topBackGroundColor
                            ? "green"
                            : "#b7e4c7",
                        }
                      : data.isBranch && data.branch === true
                      ? {
                          backgroundColor: topBackGroundColor ? "red" : "red",
                        }
                      : data.checked === true
                      ? {
                          backgroundColor: topBackGroundColor ? "red" : "red",
                        }
                      : {
                          backgroundColor: topBackGroundColor
                            ? groupcolor(data.BusinessGroup)
                            : groupcolor(data.BusinessGroup),
                        }
                  }
                  className="lower w-100 gap-4 d-flex text-light align-items-center justify-content-between pe-2 pb-3 pt-3"
                  aria-owns={open1 ? "mouse-over-popover" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={handlePopoverOpen}
                  onMouseLeave={handlePopoverClose}
                >
                  <div></div>
                  <div>
                    <h4 className="text-center ">
                      <b>{data.label}</b>
                    </h4>

                    {!data.isBranch && !data.jointcompany && (
                      <div
                        style={{
                          // color: topBackGroundColor ? "white" : "white",
                          margin: "auto",
                          textDecoration: "underline",
                          textDecorationThickness: "24px",
                          textDecorationColor: topBackGroundColor
                            ? data.isBranch === true
                              ? "green"
                              : dynamicColor
                            : dynamicColor,
                          width: "200px", // Set your desired width
                          height: "10px", // Set your desired height
                          borderBottom: `8px solid ${
                            topBackGroundColor
                              ? data.isBranch === true
                                ? "green"
                                : dynamicColor
                              : data.jointcompany === true
                              ? dynamicColor
                              : dynamicColor
                          }`,
                        }}
                      ></div>
                    )}
                  </div>

                  {data.isBranch ? (
                    <div></div>
                  ) : (
                    <div>
                      <FaBuilding
                        color={topBackGroundColor ? "white" : "white"}
                        fontSize={27}
                      />
                      <span
                        style={{
                          color: topBackGroundColor ? "white" : "white",
                        }}
                      >
                        <b>{data?.children?.length}</b>
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {data?.jointcompany === true ? (
                <div
                  className="card-head d-flex flex-column items-center justify-center py-3"
                  style={{ width: "6rem" }}
                >
                  {data?.children?.map((item, idx) => {
                  // {data?.orgchild?.map((item, idx) => {
                    const percentage =
                    item?.JointVentureCompanies?.find(
                      (itm) => itm?.childid === data?._id
                    )?.PercentageOfShares
                    ??
                    item?.shareHolders?.find(
                      (itm) => itm?.childId === data?._id
                    )?.PercentageOfShares;
                  
                  const PercentageOfShares =
                    percentage != undefined ? percentage.toFixed(2) : undefined;
                  
                    return (
                      <div
                        key={item?._id || item?.id || `orgchild-${idx}`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title={`${
                          item?.companyName
                        } = 
                        ${PercentageOfShares}
                        
                        %`}
                        className="rounded-full  text-center fs-3 rounded-pill fw-bold"
                      >
                        {PercentageOfShares}{" "}
                        %
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div
                  className="card-head d-flex flex-column items-center justify-center py-3"
                  style={{ width: "6rem" }}
                >
                  {data?.shareHolders?.map((item, idx) => {
                    return (
                      <div
                        key={item?.childId || item?._id || `shareholder-${idx}`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title={`${filterName(item?.childId)} = ${item?.PercentageOfShares?.toFixed(2)} % as shareholder`}
                        className="rounded-full  text-center fs-3 rounded-pill fw-bold"
                      >
                        {item?.PercentageOfShares?.toFixed(2)}%
                      </div>
                    );
                  })}
                  {data?.JointVentureCompanies?.map((item, idx) => {
                    return (
                      <div
                        key={item?.childid || item?._id || `JointVenture-${idx}`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        // data-bs-title={`1 %`}
                        data-bs-title={`${filterName(item?.childid)} = ${item?.PercentageOfShares?.toFixed(2)} % as Joint Venture`}
                        className="rounded-full  text-center fs-3 rounded-pill fw-bold"
                      >
                        {item?.PercentageOfShares?.toFixed(2)}%
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {
              <>
                {/* <div className="middle-transparent border w-100"></div> */}

                <div style={{ width: "29rem" }}>
                  <Typography>
                    <div className="card-body shadow border w-100">
                      <div className="d-flex justify-content-end align-items-center p-3">
                        <div></div>
                      </div>
                      {data.location && (
                        <div className="second-row-card-body px-4 my-1 d-flex justify-content-start gap-4 align-items-center">
                          <svg
                            style={{ width: "1.8rem", height: "1.8rem" }}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                              clipRule="evenodd"
                            />
                          </svg>

                          <div className="org-name">
                            <h4>
                              <b>{data.location.address}</b>
                            </h4>
                          </div>
                        </div>
                      )}
                      <div className="fourth-row-card-body ms-3 pe-5 me-4 ps-3 pt-3 pb-3 d-flex justify-content-between">
                        <div className="org-name">
                          <hr />
                        </div>
                      </div>
                    </div>
                  </Typography>
                  {data?.isBranch === true || data?.jointcompany === true
                    ? ""
                    : isEdit !== true && (
                        <Popover
                          isLazy={true}
                          id="mouse-over-popover"
                          sx={{
                            pointerEvents: "none",
                            "& .MuiPopover-paper": {
                              backgroundColor: "#f5f5f5",
                              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                              borderRadius: "10px",
                            },
                          }}
                          open={open1}
                          anchorEl={anchorEl}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                          onClose={handlePopoverClose}
                          disableRestoreFocus
                        >
                          <Typography sx={{ p: 2, color: "#333" }}>
                            <strong>Business Group:</strong>
                            {groupfilter(data.BusinessGroup) || ""}
                            <br />
                            {data.BusinessNature && (
                              <strong>Nature of Business:</strong>
                            )}
                            {data.BusinessNature || ""}
                            {data.BusinessNature && <br />}
                            {data.BusinessRegistrationNumber && (
                              <strong>Business Registration Number :</strong>
                            )}
                            {data.BusinessRegistrationNumber || ""}
                            {data.BusinessRegistrationNumber && <br />}
                            {data.Chairman && <strong>Chairman :</strong>}
                            {data.Chairman || ""}
                            {data.Chairman && <br />}
                            {data.DeputyChairman && (
                              <strong> Deputy Chairman :</strong>
                            )}
                            {data.DeputyChairman || ""}
                            {data.DeputyChairman && <br />}
                            {data.ManagingDirector && (
                              <strong>Managing Director:</strong>
                            )}
                            {data.ManagingDirector || ""}
                            {data.ManagingDirector && <br />}
                            {data.DeputyManagingDirector && (
                              <strong>Deputy Managing Director:</strong>
                            )}
                            {data.DeputyManagingDirector || ""}
                            {data.DeputyManagingDirector && <br />}
                          </Typography>
                        </Popover>
                      )}
                </div>
              </>
            }
          </div>
        </div>
      </div>
      <>
        {data.isBranch === true ? (
          ""
        ) : (
          <Handle
            type="source"
            position={Position.Bottom}
            id="bottom"
            isConnectable={isConnectable}
            style={{
              width: "100px",
              height: "24px",
              borderRadius: "13px",
              zIndex: 3333,
              position: "absolute",
              left: "250px",
              backgroundColor: `${
                data.isBranch === true && data.branch === false
                  ? "green"
                  : data.jointcompany === true
                  ? "gray"
                  : data.branch && data.isBranch === true
                  ? "red"
                  : data.checked === true
                  ? "red"
                  : groupcolor(data.BusinessGroup)
              }`,
            }}
          />
        )}

        {data?.jointcompany === true ? (
          ""
        ) : (
          <Handle
            type="target"
            position={Position.Top}
            id="top"
            isConnectable={isConnectable}
            style={{
              width: "100px",
              height: "24px",
              borderRadius: "13px",
              zIndex: 3333,
              position: "absolute",
              left: "250px",
              backgroundColor: `${
                data.branch && data.isBranch === true
                  ? "red"
                  : data.jointcompany === true
                  ? "gray"
                  : data.isBranch === true
                  ? "green"
                  : data.checked === true
                  ? "red"
                  : groupcolor(data.BusinessGroup)
              }`,
            }}
          />
        )}

        {/* <Handle
          type="target"
          position={Position.Left}
          id="left"
          isConnectable={isConnectable}
          style={{
            width: "20px",
            height: "80px",
            borderRadius: "10px",
            zIndex: 3333,
            position: "absolute",
            left: "0px",
            top: "75%",
            transform: "translateY(-50%)",
            backgroundColor: `${
              data.checked ? "red" : groupcolor(data.BusinessGroup)
            }`,
          }}
        />

        <Handle
          type="source"
          position={Position.Right}
          id="right"
          isConnectable={isConnectable}
          style={{
            width: "20px",
            height: "80px",
            borderRadius: "10px",
            zIndex: 3333,
            position: "absolute",
            left: "445px",
            top: "75%",
            transform: "translateY(-50%)",
            backgroundColor: `${
              data.checked ? "red" : groupcolor(data.BusinessGroup)
            }`,
          }}
        /> */}
      </>

      {isEdit !== true && openmodal && (
        <OrganizationModal
          open={openmodal}
          onClose={() => {
            setOpenmodal(false);
          }}
          organization={data}
          allorg={alldataorg}
        />
      )}
    </>
  );
}
const LargeCheckbox = styled(Checkbox)({
  "& .MuiSvgIcon-root": {
    fontSize: 28,
  },
});

export default React.memo(TextUpdaterNode);
